import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoutingHelpers } from './RoutingHelpers';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [RoutingHelpers]
})
export class HelpersModule { }
